import React, {memo, useCallback} from 'react';

import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';

import {AppButton, AppButtonVariant} from '@/app/shared-components';

import {
  getEditInfoImage,
  redirectToEditInfoApp,
  redirectToEditInfoAppProfile,
} from './constants';
import EditInfoLayout from './EditInfoLayout';
import {useEditInfoTrackers} from './useEditInfoTrackers';

function EditInfoExpiredContent() {
  const {t} = useTranslation();
  const location = useLocation();
  const parentId: string = location.state?.parentId ?? '';
  const teenName: string = location.state?.teenName ?? '';
  const isMoGold: boolean = location.state?.isMoGold ?? false;

  const {
    trackSelectEditInfoBackToApp,
    trackSelectEditInfoBackToAppFromExpired,
  } = useEditInfoTrackers({
    parentId,
  });

  const title = teenName
    ? t('edit_info.expired.title', {name: teenName})
    : t('edit_info.expired.title_generic');

  const primaryButtonLabel = teenName
    ? t('edit_info.expired.primary_button', {name: teenName})
    : t('edit_info.expired.primary_button_generic');

  const handleEditInfo = useCallback(() => {
    trackSelectEditInfoBackToApp();
    redirectToEditInfoApp();
  }, [trackSelectEditInfoBackToApp]);

  const handleGoBackToApp = useCallback(() => {
    trackSelectEditInfoBackToAppFromExpired();
    redirectToEditInfoAppProfile();
  }, [trackSelectEditInfoBackToAppFromExpired]);

  return (
    <EditInfoLayout
      illustrationSrc={getEditInfoImage('moSad', isMoGold)}
      title={title}
      description={t('edit_info.expired.description')}
      buttons={
        <>
          <AppButton
            id="EditInfoExpired_editInfoButton"
            sentry-label="EditInfoExpired edit info button"
            label={primaryButtonLabel}
            onClick={handleEditInfo}
            variant={
              isMoGold
                ? AppButtonVariant.onPrimary
                : AppButtonVariant.onPrimaryGreen
            }
          />
          <AppButton
            id="EditInfoExpired_goBackToAppButton"
            sentry-label="EditInfoExpired go back to app button"
            label={t('edit_info.expired.secondary_button')}
            onClick={handleGoBackToApp}
            variant={
              isMoGold
                ? AppButtonVariant.onQuinary
                : AppButtonVariant.onTertiaryGreen
            }
          />
        </>
      }
    />
  );
}

const EditInfoExpiredPage = memo(() => <EditInfoExpiredContent />);

export default EditInfoExpiredPage;
